const ADMIN_APPROVAL_ROLES = new Set([
  "super_admin",
  "project_admin",
  "cluster_manager",
]);

const PHASE_SUBMITTER_ROLES = new Set([
  "worker",
  "surveyor",
  "civil",
  "technical",
  "transport",
  "commissioning",
]);

/** Field users who can appear in Approvals “Submitted by” filter. */
export const isApprovalsSubmitterUser = (user) => {
  if (!user?.id) return false;
  const role = String(user.role || "").toLowerCase();
  if (ADMIN_APPROVAL_ROLES.has(role)) return false;
  if (PHASE_SUBMITTER_ROLES.has(role)) return true;
  if (user.category === "staff") return true;
  return false;
};

/** Who submitted work for approval (from submitted_by only). */
export const getWorkSubmitterId = (row) => {
  if (!row) return null;
  return row.submitted_by ?? null;
};

/** When work was submitted / completed for approval. */
export const getWorkSubmittedAt = (row, phase) => {
  if (!row) return null;
  if (phase === "survey") return row.submitted_at || row.updated_at || null;
  if (phase === "technical")
    return row.installation_completed_at || row.updated_at || null;
  if (phase === "commissioning")
    return row.commissioning_completed_at || row.updated_at || null;
  return row.updated_at || null;
};
